export default [{
  path: '/validacoes-sdi',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Validações de SDI Histórico',
      path: 'historico',
      component: () => import('@/views/validacoesSdi/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Validações de SDI' }
        ]
      }
    },
    {
      name: 'Validações de SDI Adicionar',
      path: 'add',
      component: () => import('@/views/validacoesSdi/Add.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Validações de SDI', path: '/validacoes-sdi/historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]